import { render, staticRenderFns } from "./GroupManagement.vue?vue&type=template&id=da4e7596&scoped=true&"
import script from "./GroupManagement.vue?vue&type=script&lang=js&"
export * from "./GroupManagement.vue?vue&type=script&lang=js&"
import style0 from "./GroupManagement.vue?vue&type=style&index=0&id=da4e7596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4e7596",
  null
  
)

export default component.exports